import * as repository from '../repository/memberPreferenceRepository';
import { MemberPreference } from '../types/memberPreference';

class MemberPreferenceServiceError extends Error {
  constructor(message: string, public cause?: Error) {
    super(message);
    this.name = 'MemberPreferenceServiceError';
  }
}

/**
 * 현재 사용자의 preference를 조회합니다. (없으면 null = 전부 기본값)
 */
export async function getOwnPreference(): Promise<MemberPreference | null> {
  try {
    return await repository.findOwn();
  } catch (error) {
    throw new MemberPreferenceServiceError('설정 조회 실패', error as Error);
  }
}

/**
 * 결제수단 기록 opt-in 값을 저장합니다.
 */
export async function setRecordPaymentMethod(userId: string, value: boolean): Promise<void> {
  try {
    await repository.upsertRecordPaymentMethod(userId, value);
  } catch (error) {
    throw new MemberPreferenceServiceError('설정 저장 실패', error as Error);
  }
}

/**
 * 배송엑셀 정렬 기준을 저장합니다.
 */
export async function setShippingExcelSort(userId: string, value: 'entry' | 'settlement'): Promise<void> {
  try {
    await repository.upsertShippingExcelSort(userId, value);
  } catch (error) {
    throw new MemberPreferenceServiceError('설정 저장 실패', error as Error);
  }
}
